module.exports = __webpack_public_path__ + "media/components/assets/img/icons/arrowhead-f5a3fc68be9494ad5698b525e9772875.svg";